import script from "./SellersTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellersTable.vue?vue&type=script&setup=true&lang=ts"

import "./SellersTable.vue?vue&type=style&index=0&id=e50e36c8&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e50e36c8"]])

export default __exports__